/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlChallengeEmailResponse
 */
export interface ControlChallengeEmailResponse {
    /**
     * 
     * @type {string}
     * @memberof ControlChallengeEmailResponse
     */
    oob_code: string;
    /**
     * 
     * @type {string}
     * @memberof ControlChallengeEmailResponse
     */
    emailed_to: string;
}

/**
 * Check if a given object implements the ControlChallengeEmailResponse interface.
 */
export function instanceOfControlChallengeEmailResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "oob_code" in value;
    isInstance = isInstance && "emailed_to" in value;

    return isInstance;
}

export function ControlChallengeEmailResponseFromJSON(json: any): ControlChallengeEmailResponse {
    return ControlChallengeEmailResponseFromJSONTyped(json, false);
}

export function ControlChallengeEmailResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlChallengeEmailResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'oob_code': json['oob_code'],
        'emailed_to': json['emailed_to'],
    };
}

export function ControlChallengeEmailResponseToJSON(value?: ControlChallengeEmailResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'oob_code': value.oob_code,
        'emailed_to': value.emailed_to,
    };
}

